import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './components/App';
import i18n from './vendors/i18n';

declare global {
  interface Window {
    td_spa: any;
  }
}

i18n.then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
